import React from 'react';
import './termsPage.scss';
import { withRouter } from 'react-router-dom';
import { withTranslation } from "react-i18next";
import Hero from '../../components/hero/hero';
import Section from '../../components/section/section';
import { PADDING_ALL } from '../../utils/styleValues';
import utils from '../../utils/utils';
import config from '../../config';

const { routes } = config;

class TermsPage extends React.Component {

    componentDidMount() {
        this.attachPrivacyLinkListener();
    }

    componentDidUpdate() {
        this.attachPrivacyLinkListener();
    }

    attachPrivacyLinkListener() {
        const links = document.querySelectorAll('.privacy-link');
        links.forEach(link => {
            // evita agregar el listener m�s de una vez
            if (!link.dataset.listenerAttached) {
                link.addEventListener('click', this._onPrivacyClick.bind(this));
                link.dataset.listenerAttached = 'true';
            }
        });
    }


    _onPrivacyClick(e) {
        const { history } = this.props;
        utils.scrollTop();
        history.push(routes.privacyPage);
    }

    render() {
        const { t } = this.props;
        let termsHtml = t('tnc:termsContent');

        return (
            <section className="page terms-page">
                <Hero title={t('termsPageTitle')} />
                <Section padding={PADDING_ALL} className="terms-page--blurb">
                    <p>{t('tnc:lastModified')}</p>
                    <div dangerouslySetInnerHTML={{ __html: termsHtml }}></div>
                </Section>
            </section>
        );
    }
}
export default withTranslation('global')(withRouter(TermsPage));
